import { UtensilsCrossed } from 'lucide-react';
import React from 'react';

import { SingleModuleAuditPage } from '@/features/imports/SingleModuleAuditPage';

export const AuditMealServiceImportsPage = (): React.JSX.Element => (
  <SingleModuleAuditPage
    config={{
      moduleKey: 'meal-service',
      titlePlural: 'meal services',
      routePrefix: 'meal-services',
      listPath: '/meal-services',
      ListIcon: UtensilsCrossed,
    }}
  />
);
